import backend from "../api";

export const startConversation = async (myId, partner) => {
  try {
    const body = {
      senderId: myId,
      receiverId: partner,
    };
    const { data } = await backend.post("/api/chat/conversations", body);
    return data.data;
  } catch (err) {
    throw new Error("Failed to start conversation: " + err.message);
  }
};